import Vue from 'vue';
import DesignBank from '@simpleinvest/design-bank-vue';
import '@simpleinvest/design-bank-vue/dist/DesignBank.css';

// common library
Vue.use(DesignBank);

Vue.config.productionTip = false;
